import { ABOUT } from "@/data/content";

export default function ClientMarquee() {
  const items = [...ABOUT.clients, ...ABOUT.clients];
  return (
    <section
      data-testid="client-marquee"
      className="border-y border-black/10 py-10 md:py-14 overflow-hidden"
    >
      <div className="flex gap-20 whitespace-nowrap animate-marquee-slow will-change-transform">
        {items.map((c, i) => (
          <span
            key={`${c}-${i}`}
            data-testid={`client-${i}`}
            className="font-serif italic font-light text-3xl md:text-5xl text-neutral-800 leading-none"
          >
            {c}
            <span className="not-italic font-sans text-neutral-300 ml-20 align-middle text-2xl md:text-3xl">
              ✦
            </span>
          </span>
        ))}
      </div>
    </section>
  );
}
